<template>
    <div class="box-preview">
        <div class="box-normal" v-if="!modal">
            <div
                class="box-container success"
                v-if="boxFile && boxFile.status == 'success'"
            >
                <iframe
                    :src="boxFile.shared_link"
                    :width="width"
                    :height="height"
                    :frameborder="frameBorder"
                    allowfullscreen
                    webkitallowfullscreen
                    mozallowfullscreen
                    oallowfullscreen
                    msallowfullscreen
                />
            </div>

            <div
                class="box-container pending"
                v-else-if="boxFile && boxFile.status == 'pending'"
            >
                <div class="alert alert-info" role="alert">
                    Please wait, getting your document ready to be previewed ...
                </div>
            </div>

            <div class="box-container failed" v-else>
                <div class="alert alert-danger" role="alert">
                    The preview is not available for this document.
                </div>
            </div>
        </div>

        <div class="box-modal" v-else>
            <slot name="toggler" :boxFile="boxFiles" :openModal="openModal">
                <span
                    class="d-inline-block"
                    tabindex="0"
                    data-toggle="tooltip"
                    :title="tooltipMessage"
                    v-on:click="openModal"
                >
                    <i :class="`fa fa-eye ${previewIconClass}`" />
                </span>
            </slot>

            <vue-modal v-model="modalOpened" style="padding: 0;">
                <template slot="body">
                    <div
                        class="box-container"
                        v-if="boxFile && boxFile.status == 'success'"
                    >
                        <iframe
                            :src="boxFile.shared_link"
                            :width="width"
                            :height="height"
                            :frameborder="frameBorder"
                            allowfullscreen
                            webkitallowfullscreen
                            mozallowfullscreen
                            oallowfullscreen
                            msallowfullscreen
                        />
                    </div>
                </template>
            </vue-modal>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

import VueModal from "simple-modal-vue";

export default Vue.extend({
    name: 'box-preview',
    components: {
        VueModal
    },
    props: {
        modal: Boolean,
        width: {
            default: "100%",
            type: String
        },
        height: {
            default: "100%",
            type: String
        },
        frameBorder: {
            default: 0,
            type: Number
        },
        boxFile: Object
    },
    data() {
        return {
            modalOpened: false
        };
    },
    computed: {
        tooltipMessage() {
            if (!this.boxFile) {
                return "The preview is not available for this file.";
            }

            switch (this.boxFile.status) {
                case "success":
                    return "Click to preview the file.";
                case "pending":
                    return "The preview is being made right now. Please wait for a few seconds.";
                default:
                    return "The preview is not available for this file.";
            }
        },
        previewIconClass() {
            if (!this.boxFile) {
                return "text-secondary";
            }

            switch (this.boxFile.status) {
                case "success":
                    return "text-primary";
                case "pending":
                    return "text-warning";
                default:
                    return "text-secondary";
            }
        }
    },
    methods: {
        openModal() {
            if (this.boxFile && this.boxFile.status == "success") {
                this.modalOpened = true;
            }
        },
        subscribeToPusher() {
            if (!this.boxFile || this.boxFile.status != "pending") {
                return;
            }

            window.Echo.private(`box-files.${this.boxFile.id}`).listen(
                "BoxUploadStatus",
                data => {
                    this.boxFile.status = data.box_file.status;
                    this.boxFile.shared_link = data.box_file.shared_link;
                    this.boxFile.box_id = data.box_file.box_id;
                }
            );
        }
    },
    mounted() {
        this.subscribeToPusher();
    }
});
</script>

<style scoped lang="scss">
.box-preview {
    height: 100%;

    .box-modal {
        .fa {
            cursor: pointer;
            pointer-events: none;
        }

        .box-container {
            margin: -16px;
        }
    }

    .box-normal {
        height: 100%;

        .box-container {
            height: 100%;
        }
    }
}
</style>
